<template>

  <the-json-pretty :data="props" />

  <div class="loader relative flex items-center" :class="{'flex-col': !inline, 'justify-start': !center, 'justify-center': center}">
    <span class="loading loading-ball loading-md"></span>
    <span class="text-center block text-sm muted">
      {{ message }}
    </span>
  </div>


</template>

<style scoped>



</style>

<script setup>

const props = defineProps({
  message: {
    type: String,
    default: ""
  },
  inline: {
    type: Boolean,
    default: true
  },
  center: {
    type: Boolean,
    default: true
  }
});

</script>